import { SyncableRecord } from "./syncable-record";

export type MealSlot = "breakfast" | "lunch" | "dinner" | "extra";

// Fixed slot order (drives display order within a day).
export const MEAL_SLOTS: MealSlot[] = ["breakfast", "lunch", "dinner", "extra"];

export const MEAL_SLOT_LABELS: Record<MealSlot, string> = {
  breakfast: "Breakfast",
  lunch: "Lunch",
  dinner: "Dinner",
  extra: "Snacks & Other",
};

// Meal-slot value → i18n key (display only; the stored slot is the identifier).
// The full labels are used for planner slot headers/toasts; the short variant
// (extra = "Snacks") fits the compact day/slot picker chips.
export const MEAL_SLOT_LABEL_KEYS: Record<MealSlot, string> = {
  breakfast: "labels.mealSlot.breakfast",
  lunch: "labels.mealSlot.lunch",
  dinner: "labels.mealSlot.dinner",
  extra: "labels.mealSlot.extra",
};

export const MEAL_SLOT_SHORT_KEYS: Record<MealSlot, string> = {
  breakfast: "labels.mealSlot.breakfast",
  lunch: "labels.mealSlot.lunch",
  dinner: "labels.mealSlot.dinner",
  extra: "labels.mealSlot.extraShort",
};

// A recipe placed on a specific calendar day + slot in the meal planner.
export interface PlannedMeal extends SyncableRecord {
  recipeId: string;
  mealDate: string; // "YYYY-MM-DD" (local calendar day; sorts chronologically as a string)
  slot: MealSlot;
  sortOrder: number; // ordering within a day + slot
}
